import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { typography } from '../../styles';


const styles = css`
  width:100%;
  position: relative;
  max-width: 1600px;
  margin:0 auto;
  margin-bottom:40px;
  @media (min-width: 768px) {
    margin-bottom:100px;
  }
  @media (min-width: 992px) {
    margin:0 auto 100px auto;
  }

  .Banner_Result {
    margin:0 auto;
    display:flex;
    flex-flow:row wrap;
    justify-content: flex-start;
    width:100%;
  }
  .Banner_Media {
    width:100%;
    overflow: hidden;
    padding-top: 60%;
    position: relative;
    background-size:cover;
    background-position: center;
    margin-bottom:20px;
    @media (min-width: 992px) {
      width:66.66666%;
    }
  }
  .Banner_Media:nth-child(even) {
    width:100%;
    overflow: hidden;
    position: relative;
    background-size:cover;
    background-position: center;
    @media (min-width: 992px) {
      width:33.33333%;
      border-left: 20px solid white;
    }
  }
  .Banner_Media_Label {
    font:700 16px/1 ${typography.SansSerif};
    display:block;
    position:absolute;
    bottom:20px;
    left:20px;
    color:  white;
    font:700 16px/1 ${typography.SansSerif};
  }
`;

function HomeDetailPhotoGrid({ home }) {
  return (
    <div className={styles}>
      {
        get(home, 'photos').length > 1 &&
        <div className="Banner_Wrapper">
          <div className="Banner_Result">
            <div className="Banner_Media" style={{ backgroundImage: `url('${buildThumbnailUrl(get(home, 'photos[1].contentUrl'), { width: 1200, height: 1200 })}')` }} >
              {/* <img src={page.showcase_section[0].project_one[0].image.contentUrl} alt="" /> */}
              {/* <span className="Banner_Media_Label">{home.photos[1].caption}</span> */}
            </div>
            <div className="Banner_Media" style={{ backgroundImage: `url('${buildThumbnailUrl(get(home, 'photos[2].contentUrl'), { width: 1200, height: 1200 })}')` }} >
              {/* <img src={page.showcase_section[0].project_one[0].image.contentUrl} alt="" /> */}
              {/* <span className="Banner_Media_Label">{home.photos[2].caption}</span> */}
            </div>
          </div>
        </div>
      }
    </div>
  );
}

HomeDetailPhotoGrid.propTypes = {
  home: PropTypes.object.isRequired,
};

export default withData(
  {
    home: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeDetailPhotoGrid);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDetailPhotoGrid.js